import Joi from 'joi';
import PropTypes from 'prop-types';
import Form from '../../../common/form';
import Button from '../../../themed/button';

class PECHorizontalColumnsEdit extends Form {
	state = {
		data: { label: '' },
		errors: {},
		loading: false,
		progress: 0,
	};

	schema = {
		label: Joi.number().required().label('Label'),
	};

	static propTypes = {
		label: PropTypes.number,
		onEdit: PropTypes.func,
		onEditCancel: PropTypes.func
	};

	componentDidMount() {
		if (this.props.label) {
			this.setState({ data: { label: this.props.label }});
		}
	}

	doSubmit = (): void => {
		this.props.onEdit(+this.state.data.label);
	};

	render() {
		return (
			<form autoComplete="off" onSubmit={this.handleSubmit}>
				<h2 className="form-title">Data Sheet Reading (Edit Axial Value)</h2>

				<div className="container-fluid">
					<div className="row">
						<div className="col">
							{this.renderInput({
								type: 'number',
								name: 'label',
								placeholder: 'Enter New Axial Value',
								label: 'New Axial Value',
							})}
						</div>
						<div className="col">
							<div className="d-flex align-items-center">
								{this.renderButton('Save Changes')}

								<div className="mx-4">
									<Button label='Cancel' style={{ backgroundColor: 'red' }} onClick={() => this.props.onCancelEdit} />
								</div>
							</div>
						</div>
					</div>
				</div>

			</form>
		);
	}
}

export default PECHorizontalColumnsEdit;
